import { ENDPOINTS, useActions } from 'hammock';
import { useEffect, useRef, useState } from 'react';

import { CollectionDefinition } from '@candu-ai/collections/types';

export const useCollectionDefinitions = (collectionIds: string[]): CollectionDefinition[] => {
  const [collectionDefinitions, setCollectionDefinitions] = useState<CollectionDefinition[]>();
  const mountedRef = useRef(true);

  const { getAll } = useActions(ENDPOINTS.collections);

  useEffect(() => {
    getAll().then((res) => {
      if (res && mountedRef.current) {
        setCollectionDefinitions(res as CollectionDefinition[]);
      }
    });

    return () => {
      mountedRef.current = false;
    };
  }, [collectionIds.join(',')]);

  if (!collectionDefinitions) {
    return [];
  }

  return collectionDefinitions.filter((collection) => collectionIds.includes(collection.id));
};
